import { useState, useCallback, useEffect } from 'react';
import { stockyApi } from '../components/misc/StockyApi';

export const useNotifications = (authUser, initialFilters, options = {}) => {
  const { onRowsChange } = options;
  const [candidateData, setCandidateData] = useState({
    data: [],
    page: 1,
    pageSize: 20,
    total: 0,
    pendingCount: 0,
  });
  const [notificationPage, setNotificationPage] = useState(1);
  const [notificationFilters, setNotificationFilters] = useState(initialFilters);
  const [loadingNotifications, setLoadingNotifications] = useState(true);
  const [notificationsError, setNotificationsError] = useState(null);
  const [summary, setSummary] = useState({ unreadCount: 0, latest: [] });

  const loadNotifications = useCallback(async () => {
    if (!authUser) return;
    setLoadingNotifications(true);
    setNotificationsError(null);
    try {
      const [summaryResponse, candidatesResponse] = await Promise.all([
        stockyApi.getNotificationSummary(authUser, 5),
        stockyApi.getMarketplaceListingCandidates(authUser, {
          page: notificationPage,
          pageSize: 20,
          search: notificationFilters.search,
          marketplace: notificationFilters.marketplace,
          status: notificationFilters.status,
          sellerId: notificationFilters.sellerId,
        }),
      ]);

      const nextRows = Array.isArray(candidatesResponse?.data?.data)
        ? candidatesResponse.data.data
        : [];

      setSummary({
        unreadCount: Number(summaryResponse?.data?.unreadCount || 0),
        latest: Array.isArray(summaryResponse?.data?.latest)
          ? summaryResponse.data.latest
          : [],
      });
      setCandidateData({
        data: nextRows,
        page: Number(candidatesResponse?.data?.page || notificationPage),
        pageSize: Number(candidatesResponse?.data?.pageSize || 20),
        total: Number(candidatesResponse?.data?.total || 0),
        pendingCount: Number(candidatesResponse?.data?.pendingCount || 0),
      });
      if (typeof onRowsChange === 'function') {
        onRowsChange(nextRows);
      }
    } catch (error) {
      console.error('Error loading notification candidates:', error);
      setNotificationsError({
        title: 'No pudimos cargar las notificaciones',
        content: 'Intentá nuevamente en unos segundos.',
      });
    } finally {
      setLoadingNotifications(false);
    }
  }, [authUser, notificationPage, notificationFilters, onRowsChange]);

  useEffect(() => {
    loadNotifications();
  }, [loadNotifications]);

  return {
    candidateData,
    notificationPage,
    setNotificationPage,
    notificationFilters,
    setNotificationFilters,
    loadingNotifications,
    notificationsError,
    summary,
    loadNotifications,
  };
};
